export const getLombardieData = () => ({
  name: "Lombardie",
  country: "Italie",
  description: "La Lombardie est une région viticole importante du nord de l'Italie, s'étendant des Alpes à la plaine du Pô. Cette région produit une grande variété de vins, des vins effervescents de qualité aux vins rouges structurés, avec une forte identité alpine.",
  type: "region",
  mapAreas: [
    { region: "Lombardie", x: 50, y: 38, color: "#4B164C", size: 4 }
  ],
  statistics: {
    totalArea: "23,000 ha",
    production: "1.5 million hectolitres",
    appellations: "22 DOC et 5 DOCG",
    provinces: "12 provinces",
    exportPercentage: "25%"
  },
  characteristics: {
    climate: "Climat continental avec influence alpine et méditerranéenne",
    soil: "Sols très variés : moraines glaciaires, calcaire, argile",
    viticulture: "Viticulture traditionnelle et moderne, cépages autochtones"
  },
  wineStyles: {
    red: "Vins rouges élégants et structurés, du léger au puissant",
    white: "Vins blancs secs et aromatiques, frais et complexes",
    rose: "Rosés frais et fruités, parfaits pour l'apéritif",
    sparkling: "Franciacorta et vins effervescents de qualité"
  },
  history: "La viticulture dans la Lombardie remonte à l'époque romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XIXe siècle a vu l'émergence des appellations. Aujourd'hui, la Lombardie est reconnue pour ses vins de qualité et ses cépages autochtones.",
  foodPairing: "Cuisine lombarde, risottos, fromages, charcuteries, cuisine alpine",
  subregions: {
    "franciacorta": {
      name: "Franciacorta",
      description: "Région prestigieuse produisant des vins effervescents de qualité, méthode traditionnelle, avec une forte identité alpine.",
      characteristics: {
        climate: "Climat continental avec influence alpine",
        soil: "Sols morainiques et calcaires",
        viticulture: "Viticulture traditionnelle, méthode traditionnelle"
      },
      grapeVarieties: {
        white: ["Chardonnay", "Pinot Blanc", "Pinot Gris"],
        red: ["Pinot Noir"]
      },
      wineStyles: {
        "franciacorta-brut": "Vins effervescents secs et équilibrés",
        "franciacorta-rose": "Vins effervescents rosés élégants",
        "franciacorta-saten": "Vins effervescents blancs doux"
      },
      foodPairing: "Apéritifs, fruits de mer, poissons, fromages, cuisine lombarde"
    },
    "valtellina": {
      name: "Valtellina",
      description: "Vallée alpine produisant des vins rouges de qualité, principalement à base de Nebbiolo, avec une forte identité montagneuse.",
      characteristics: {
        climate: "Climat continental avec influence alpine",
        soil: "Sols granitiques et schisteux",
        viticulture: "Viticulture en terrasses, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Nebbiolo (Chiavennasca)", "Rossola", "Pignola"]
      },
      wineStyles: {
        "valtellina-superiore": "Vins rouges structurés et tanniques",
        "sforzato-valtellina": "Vins rouges puissants et concentrés"
      },
      foodPairing: "Viandes rouges, gibier, fromages affinés, cuisine alpine"
    },
    "oltrepò-pavese": {
      name: "Oltrepò Pavese",
      description: "Région méridionale produisant des vins rouges et blancs de qualité, avec une forte identité locale.",
      characteristics: {
        climate: "Climat continental tempéré",
        soil: "Sols argileux et calcaires",
        viticulture: "Viticulture traditionnelle, rendements limités"
      },
      grapeVarieties: {
        red: ["Barbera", "Bonarda", "Pinot Noir"],
        white: ["Riesling", "Pinot Grigio", "Cortese"]
      },
      wineStyles: {
        "barbera-oltrepo": "Vins rouges fruités et équilibrés",
        "bonarda-oltrepo": "Vins rouges légers et fruités",
        "pinot-nero-oltrepo": "Vins rouges élégants et structurés"
      },
      foodPairing: "Viandes rouges, volailles, fromages, cuisine traditionnelle"
    },
    "lugana": {
      name: "Lugana",
      description: "Région lacustre produisant des vins blancs secs et aromatiques, avec une forte identité terroir.",
      characteristics: {
        climate: "Climat continental avec influence lacustre",
        soil: "Sols argileux et calcaires",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        white: ["Turbiana (Trebbiano di Lugana)"]
      },
      wineStyles: {
        "lugana-bianco": "Vins blancs secs et aromatiques",
        "lugana-superiore": "Vins blancs secs et structurés"
      },
      foodPairing: "Poissons, fruits de mer, volailles, cuisine lacustre"
    }
  }
}); 